import { render, staticRenderFns } from "./FileBrowser.vue?vue&type=template&id=b622e24c&scoped=true&"
import script from "./FileBrowser.vue?vue&type=script&lang=js&"
export * from "./FileBrowser.vue?vue&type=script&lang=js&"
import style0 from "./FileBrowser.vue?vue&type=style&index=0&id=b622e24c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b622e24c",
  null
  
)

export default component.exports